import { openNotification } from "../../../globals/Components/Notification/Notification";
import { serverMessages } from "../../serverMessages";
import { setMessageResponse, toggleLoadingIndicator } from "../../system/actions";
import { MessageResponse } from "../../system/types";
import { AppThunk } from "../../thunks";
import type { CreatePedidoRequest } from "./types";
import {
    createPedidoAPI,
    confirmarPagoAPI,
    rechazarPagoAPI,
    cancelarPedidoAPI,
    cancelarMiPedidoAPI,
    marcarEntregadoAPI,
    getAllPedidosAPI,
    getMisPedidosAPI,
    getPedidoByIdAPI,
} from "./restCallPedidos";

export const createPedido = (value: CreatePedidoRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await createPedidoAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return null;
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
    return null;
};

export const confirmarPago = (pagoId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await confirmarPagoAPI(pagoId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return false;
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("", "Pago confirmado");
        return true;
    }
    dispatch(toggleLoadingIndicator(false));
    return false;
};

export const rechazarPago = (pagoId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await rechazarPagoAPI(pagoId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return false;
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("", "Pago rechazado");
        return true;
    }
    dispatch(toggleLoadingIndicator(false));
    return false;
};

export const cancelarPedido = (pedidoId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await cancelarPedidoAPI(pedidoId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return false;
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("", "Pedido cancelado");
        return true;
    }
    dispatch(toggleLoadingIndicator(false));
    return false;
};

export const cancelarMiPedido = (pedidoId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await cancelarMiPedidoAPI(pedidoId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return false;
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("", "Reserva cancelada");
        return true;
    }
    dispatch(toggleLoadingIndicator(false));
    return false;
};

export const marcarEntregado = (pedidoId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await marcarEntregadoAPI(pedidoId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return false;
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("", "Pedido marcado como entregado");
        return true;
    }
    dispatch(toggleLoadingIndicator(false));
    return false;
};

export const getAllPedidos = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllPedidosAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return [];
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
    return [];
};

export const getMisPedidos = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getMisPedidosAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return [];
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
    return [];
};

export const getPedidoById = (id: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPedidoByIdAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return null;
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
    return null;
};
